import { Feature } from '@/featureflag_manager';
import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'rag',
    name: RouteNames.RAG_HOME,
    redirect: { name: RouteNames.RAG_LIST },
    meta: {
      feature_flag: Feature.RAG,
    },
    children: [
      {
        name: RouteNames.RAG_LIST,
        path: '',
        components: {
          default: () => import('../pages/StagesAndSearchStoresList.vue'),
        },
      },
      {
        name: RouteNames.RAG_FILES_LIST,
        path: ':searchStoreId',
        components: {
          default: () => import('../pages/SeachStoresDocumentsList.vue'),
        },
      },
    ],
  },
];
export default routes;
